import { api } from "./configs/axiosConfigs"

export const priceListSalesmanAPI = {
    
    getPriceListSalesman: async (data:any) => {
        const response = await api.get(
            '/priceListSalesman', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    createPriceListSalesman: async (data: any) => {
        const response = await api.post(
            '/priceListSalesman/register', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    
    editPriceListSalesman: async (idlist: number, data: any) => {
        const response = await api.patch(
            `/priceListSalesman/${idlist}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    deletePriceListSalesman: async (idlist: number) => {
        const response = await api.delete(
            `/priceListSalesman/${idlist}`
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
}